<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-present"></i> 金豆订单列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">用户名称/订单号</span>
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入用户名称或订单号"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-actions">
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-present"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">订单总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon paid"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ paidCount }}</div>
            <div class="stat-label">已支付订单</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon beans"><i class="el-icon-present"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ totalBeans }}</div>
            <div class="stat-label">总金豆数</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="用户信息" min-width="150">
            <template slot-scope="scope">
              <div class="user-info">
                <div class="user-name">
                  <i class="el-icon-user"></i>
                  <span>{{ scope.row.user ? scope.row.user.user_name : '-' }}</span>
                </div>
                <div class="user-phone" v-if="scope.row.user && scope.row.user.mobile">
                  <i class="el-icon-phone"></i>
                  <span>{{ scope.row.user.mobile }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="订单信息" min-width="220">
            <template slot-scope="scope">
              <div class="order-info">
                <div class="order-sn">
                  <i class="el-icon-document"></i>
                  <span>{{ scope.row.order_sn }}</span>
                </div>
                <div class="order-beans">
                  <i class="el-icon-present"></i>
                  <span class="bean-amount">{{ scope.row.bean_amount }} 金豆</span>
                </div>
                <div class="order-time">
                  <i class="el-icon-date"></i>
                  <span>{{ scope.row.add_time | dateFormat }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="支付信息" width="140" align="center">
            <template slot-scope="scope">
              <div class="pay-info">
                <div class="pay-method">
                  <el-tag size="small" type="info" effect="plain">
                    {{ scope.row.pay_id == 6 ? '微信支付' : (scope.row.pay_name || '-') }}
                  </el-tag>
                </div>
                <div class="pay-time" v-if="scope.row.pay_time">
                  <span class="time-text">{{ scope.row.pay_time | timeFormat }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="收货信息" min-width="220">
            <template slot-scope="scope">
              <div class="receive-info">
                <div class="receiver">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ scope.row.consignee || '-' }}</span>
                  <span class="phone">({{ scope.row.tel || '-' }})</span>
                </div>
                <div class="address">
                  <i class="el-icon-location"></i>
                  <span>{{ scope.row.address || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="订单状态" width="110" align="center">
            <template slot-scope="scope">
              <div class="status-badges">
                <el-tag v-if="scope.row.pay_status == 2" size="small" type="success" effect="plain">
                  已支付
                </el-tag>
                <el-tag v-if="scope.row.shipping_status == 1" size="small" type="primary" effect="plain">
                  已发货
                </el-tag>
                <el-tag v-if="scope.row.shipping_status == 2" size="small" type="success" effect="plain">
                  已收货
                </el-tag>
                <span v-if="scope.row.pay_status != 2 && scope.row.shipping_status == 0" class="status-wait">
                  待支付
                </span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="detail-btn"
                @click="goInfo(scope.row)"
              >
                <i class="el-icon-view"></i> 详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-present"></i>
        <p>暂无金豆订单数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "beanOrderList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: ""
      },
      
      // 统计数据
      paidCount: 0,
      totalBeans: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      showType: ''
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    },
    timeFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() { return { cursor: 'pointer' } },
    
    calculateStats() {
      if (!this.tableLoadData.length) {
        this.paidCount = 0
        this.totalBeans = 0
        return
      }
      this.paidCount = this.tableLoadData.filter(item => item.pay_status == 2).length
      this.totalBeans = this.tableLoadData.reduce((sum, item) => sum + (parseInt(item.bean_amount) || 0), 0)
    },
    
    resetSearch() {
      this.searchForm = { name: "" }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        showType: this.showType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cate_id: 2
      }
      if (this.searchForm.name) param.keyword = this.searchForm.name
      
      this.$axios.orderList(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    goInfo(row) {
      this.$router.push({
        path: '/shopOrderInfo',
        query: { id: row.order_id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    .search-label { font-size: 13px; color: #606266; white-space: nowrap; min-width: 120px; text-align: right; }
    .search-input { width: 260px; }
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    margin-left: auto;
    .el-button { border-radius: 20px; padding: 8px 18px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 140px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 16px 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.paid { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.beans { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.user-info {
  .user-name { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #1677ff; } span { font-weight: 500; } }
  .user-phone { display: flex; align-items: center; gap: 6px; i { color: #00b578; font-size: 12px; } span { font-size: 12px; color: #8c8f98; } }
}

.order-info {
  .order-sn, .order-beans, .order-time { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; i { font-size: 14px; } }
  .order-sn i { color: #1677ff; }
  .order-beans i { color: #e6a23c; }
  .order-time i { color: #8c8f98; }
  .bean-amount { font-weight: 600; color: #e6a23c; font-size: 14px; }
}

.pay-info {
  .pay-method { margin-bottom: 4px; }
  .pay-time .time-text { font-size: 12px; color: #8c8f98; }
}

.receive-info {
  .receiver { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #00b578; } .phone { margin-left: 8px; color: #8c8f98; font-size: 12px; } }
  .address { display: flex; align-items: center; gap: 6px; i { color: #909399; } span { font-size: 12px; color: #606266; } }
}

.status-badges { display: flex; flex-wrap: wrap; gap: 6px; justify-content: center; .status-wait { font-size: 12px; color: #909399; } }
.detail-btn { color: #1677ff; i { margin-right: 4px; } &:hover { color: #4096ff; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

@media (max-width: 768px) {
  .search-bar .search-item .search-label { min-width: 90px; }
  .search-bar .search-item .search-input { width: 180px; }
}
</style>